import {
  OR_RECEIVE_DAYS,
  OR_RECEIVE_DAYS_ERROR,
  OR_REQUEST_DAYS,
} from '../../../actions/management/orSettings';
import WEEKDAYS from '../../../utils/weekdays';

export const initialState = {
  daysList: WEEKDAYS,
  isFetchingDays: false,
  isFetchingDaysError: false,

};

export default function daysReducer(state = initialState, action) {
  switch (action.type) {
    case OR_REQUEST_DAYS:
      return { ...state, isFetchingDays: true };
    case OR_RECEIVE_DAYS:
      return {
        ...initialState,
        daysList: initialState.daysList.map(
          day => ({ ...day, isActive: action.data.daysOfWeek.includes(day.value) })
        ),
      };

    case OR_RECEIVE_DAYS_ERROR:
      return {
        ...state,
        isFetchingDays: false,
        isFetchingDaysError: true,
      };
    default:
      return state;
  }
}
